import { Component, DestroyRef, inject, NgZone, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { ActivatedRoute } from '@angular/router';
import { from } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-request',
    templateUrl: './request.component.html',
    styleUrls: ['./request.component.scss'],
    standalone: false
})
export class RequestComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  success = false;
  fail = false;
  loadingMessage = "Accepting request..."

  constructor(
    private route: ActivatedRoute,
    private functions: Functions,
    private zone: NgZone,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.route.queryParamMap.pipe(take(1)).subscribe(qParams => {
        console.log(params.get('reqId'));
        console.log(qParams.get('accept'));

        if(qParams.get('accept')) {
          const acceptRequestFn = httpsCallable(this.functions, 'acceptRequest');

          from(acceptRequestFn({
            reqId: params.get('reqId'),
          })).pipe(take(1)).subscribe(result => {
            this.zone.run(() => {
              const res = result.data as any;
              console.log(res);

              if(res.success) {
                this.success = true;
              }
              else {
                this.fail = true;
              }
            });
          })
        }
      })
    })
  }

}
